import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, Edit, BookOpen } from 'lucide-react';
import "./components.css";
import { constructQuestionPostPayload, constructReportedQuestionPutPayload } from '../utils/PayloadUtils';
import { getAdminQuestionGetByIdUrl, getAdminQuestionPutUrl, getTagUrl, reportedQuestionGetUrl, reportedQuestionPutUrl } from '../utils/UrlUtilities';
import { useApiCaller } from '../utils/ApiUtilities';
import { isEmpty } from '../utils/BasicUtilities';
import { CORRECTOPTION, QUESTIONDIFFICULTY, TAGLEVELS, itemsPerPageOptions } from '../utils/Constants';
import CloseButton from './ui/CloseButton';
import QuestionPreviewModal from './QuestionPreviewModal';


// const useApiCaller = () => {
//     return useCallback(async ({ url, method, token, payload, data }) => {
//         console.log(`API Call: ${method} ${url}, Token: ${token}, Payload/Data:`, payload || data);
//         await new Promise(resolve => setTimeout(resolve, 700)); // Simulate network delay

//         if (url.startsWith('/api/reported-questions')) {
//             if (method === 'GET') {
//                 const urlParams = new URLSearchParams(url.split('?')[1]);
//                 const page = parseInt(urlParams.get('page') || '1');
//                 const limit = parseInt(urlParams.get('limit') || '50');
//                 const user_email = urlParams.get('user_email');
//                 const resolution_status = urlParams.get('resolution_status');
//                 const reasons = {
//                     reason_wrong_text: urlParams.get('reason_wrong_text') === 'true',
//                     reason_wrong_answer: urlParams.get('reason_wrong_answer') === 'true',
//                     reason_bad_question: urlParams.get('reason_bad_question') === 'true',
//                     reason_out_of_syllabus: urlParams.get('reason_out_of_syllabus') === 'true',
//                     reason_other: urlParams.get('reason_other') === 'true',
//                 };

//                 let filteredData = mockReportedData.filter(report => {
//                     let match = true;
//                     if (user_email && !report.user_email.includes(user_email)) match = false;
//                     if (resolution_status && report.resolution_status !== resolution_status) match = false;

//                     const hasReasonFilter = Object.values(reasons).some(Boolean);
//                     if (hasReasonFilter) {
//                         let reasonMatch = false;
//                         if (reasons.reason_wrong_text && report.reason_wrong_text) reasonMatch = true;
//                         if (reasons.reason_wrong_answer && report.reason_wrong_answer) reasonMatch = true;
//                         if (reasons.reason_bad_question && report.reason_bad_question) reasonMatch = true;
//                         if (reasons.reason_out_of_syllabus && report.reason_out_of_syllabus) reasonMatch = true;
//                         if (reasons.reason_other && report.reason_other) reasonMatch = true;
//                         if (!reasonMatch) match = false;
//                     }

//                     return match;
//                 });

//                 const total = filteredData.length;
//                 const startIndex = (page - 1) * limit;
//                 const endIndex = startIndex + limit;
//                 const paginatedData = filteredData.slice(startIndex, endIndex);

//                 return {
//                     success: true,
//                     data: paginatedData,
//                     page: page,
//                     limit: limit,
//                     total: total
//                 };
//             } else if (method === 'PATCH') {
//                 const reportId = parseInt(url.split('/').pop());
//                 const updatedStatus = data.resolution_status;
//                 const updatedComment = data.resolution_comment;

//                 const reportIndex = mockReportedData.findIndex(r => r.report_id === reportId);
//                 if (reportIndex !== -1) {
//                     mockReportedData[reportIndex] = {
//                         ...mockReportedData[reportIndex],
//                         resolution_status: updatedStatus,
//                         resolution_comment: updatedComment,
//                         resolution_status_updated_by_email: "mock_admin@example.com",
//                         updated_at: new Date().toISOString(),
//                     };
//                     return { success: true, message: 'Report updated successfully!' };
//                 }
//                 return { success: false, message: 'Report not found for PATCH.' };
//             }
//         } else if (url.startsWith('/api/admin/questions/')) {
//             const questionId = url.split('/').pop();
//             if (method === 'PUT') {
//                 console.log(`Mocking PUT for question_id: ${questionId} with payload:`, payload);
//                 if (mockQuestionsData[questionId]) {
//                     mockQuestionsData[questionId] = { ...mockQuestionsData[questionId], ...payload };
//                 }
//                 return { success: true, message: 'Question updated successfully!' };
//             }
//         } else if (url.startsWith('/api/questions/')) {
//             const questionId = url.split('/').pop();
//             if (method === 'GET') {
//                 if (mockQuestionsData[questionId]) {
//                     return { success: true, data: mockQuestionsData[questionId] };
//                 } else {
//                     return { success: false, message: 'Question not found' };
//                 }
//             }
//         } else if (url === '/api/tags') {
//             if (method === 'GET') {
//                 return { success: true, data: mockTags };
//             }
//         }
//         return { success: false, data: null, message: 'Unknown API endpoint or method' };
//     }, []);
// };


// const patchReportedQuestionUrl = (reportId) => `/api/reported-questions/${reportId}`;
// const getQuestionByIdUrl = (questionId) => `/api/questions/${questionId}`;
// const getAdminQuestionPutUrl = (questionId) => `/api/admin/questions/${questionId}`;
// const getTagUrl = () => `/api/tags`;

// --- MOCK UTILITIES END ---


// QuestionEditForm Component
const QuestionEditForm = ({ question, onCancel, onSave }) => {
    const [text, setText] = useState('');
    const [optionA, setOptionA] = useState('');
    const [optionB, setOptionB] = useState('');
    const [optionC, setOptionC] = useState('');
    const [optionD, setOptionD] = useState('');
    const [correctOption, setCorrectOption] = useState('');
    const [answerExplanation, setAnswerExplanation] = useState('');
    const [level, setLevel] = useState('');
    const [topic, setTopic] = useState('');
    const [subject, setSubject] = useState('');
    const [exam, setExam] = useState('');
    const [difficulty, setDifficulty] = useState('');

    const [tags, setTags] = useState([]);
    const CallApi = useApiCaller();
    const [isSaving, setIsSaving] = useState(false);
    const [saveError, setSaveError] = useState(null);
    const [showPreview, setShowPreview] = useState(false);


    const handleSave = async () => {
        setIsSaving(true);
        setSaveError(null);
        try {
            const newQuestionPayload = constructQuestionPostPayload({
                text,
                options: { option_a: optionA, option_b: optionB, option_c: optionC, option_d: optionD },
                correctOption,
                answerExplanation, level, topic, subject, exam, difficulty,
            });
            console.log("put payload via post function: ", newQuestionPayload);
            const newQuestionPutUrl = getAdminQuestionPutUrl(question.question_id);
            console.log("newQuestionPutUrl :: ", newQuestionPutUrl);
            const putQuestionResponse = await CallApi({
                url: newQuestionPutUrl,
                method: 'PUT',
                payload: newQuestionPayload,
                token: true,
            });

            if (putQuestionResponse.success) {
                console.log('Question updated successfully!');
                onSave(putQuestionResponse.data);
            } else {
                setSaveError(putQuestionResponse.message || 'Failed to update question.');
                console.error('Edit Question Error:', putQuestionResponse);
            }
        } catch (error) {
            setSaveError('An unexpected error occurred while saving.');
            console.error('Edit Question Error in catch block:', error);
        } finally {
            setIsSaving(false);
        }
    };

    const fetchTags = async () => {
        try {
            const tagUrl = getTagUrl();
            const tagGetResponse = await CallApi({
                url: tagUrl,
                method: 'GET',
                token: true,
            });
            if (tagGetResponse.success) {
                setTags(tagGetResponse.data.tags);
            } else {
                setTags([]);
            }
        } catch (error) {
            setTags([]);
            console.error("Error fetching tags:", error);
        }
    };

    useEffect(() => {
        if (question) {
            setText(question.question_text || '');
            setOptionA(question.option_a || '');
            setOptionB(question.option_b || '');
            setOptionC(question.option_c || '');
            setOptionD(question.option_d || '');
            setCorrectOption(question.correct_option || '');
            setAnswerExplanation(question.answer_explanation || "");
            setLevel(question.level || "");
            setSubject(question.subject || "");
            setTopic(question.topic || "");
            setExam(question.exam || "");
            setDifficulty(question.difficulty || "");
        }
        fetchTags();
    }, [question]);

    const isFormValid = text && optionA && optionB && optionC && optionD && correctOption && level && subject && difficulty;

    return (
        <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content h-75 d-flex flex-column">
                    <div className="modal-header">
                        <h5 className="modal-title fs-4 fw-bold text-dark border-bottom pb-3">
                            Edit Question (ID: {question?.question_id})
                        </h5>
                        <div className="d-flex align-items-center gap-2">
                            <button type="button" className="btn btn-sm" style={{ background: "linear-gradient(145deg, #8b5cf6, #6d28d9)", color: "#fff", border: "none", fontWeight: 600, whiteSpace: "nowrap", marginLeft: "1rem" }} onClick={() => setShowPreview(true)}>👁 Preview Question In Test</button>
                            <CloseButton onClick={onCancel} style={{ top: '1rem', right: '1rem' }} />
                        </div>

                    </div>

                    {saveError && (
                        <div className="alert alert-danger text-center mx-3 mt-3 p-2 rounded" role="alert">
                            {saveError}
                        </div>
                    )}

                    <div className="modal-body flex-grow-1 overflow-auto custom-scrollbar px-4 pb-3">
                        <form onSubmit={(e) => e.preventDefault()} className="space-y-3">
                            <div className="mb-3">
                                <label htmlFor="question-text" className="form-label text-gray-700">
                                    Question Title <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    id="question-text"
                                    value={text}
                                    onChange={(e) => setText(e.target.value)}
                                    className="form-control"
                                    required
                                    rows={7}
                                    placeholder="Enter your question here..."
                                    style={{ resize: 'vertical' }}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="option-a" className="form-label text-gray-700">Option A <span className="text-danger">*</span></label>
                                <textarea
                                    id="option-a"
                                    value={optionA}
                                    onChange={(e) => setOptionA(e.target.value)}
                                    className="form-control"
                                    required
                                    rows={3}
                                    placeholder="Enter option A here..."
                                    style={{ resize: 'vertical' }}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="option-b" className="form-label text-gray-700">Option B <span className="text-danger">*</span></label>
                                <textarea
                                    id="option-b"
                                    value={optionB}
                                    onChange={(e) => setOptionB(e.target.value)}
                                    className="form-control"
                                    required
                                    rows={3}
                                    placeholder="Enter option B here..."
                                    style={{ resize: 'vertical' }}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="option-c" className="form-label text-gray-700">Option C <span className="text-danger">*</span></label>
                                <textarea
                                    id="option-c"
                                    value={optionC}
                                    onChange={(e) => setOptionC(e.target.value)}
                                    className="form-control"
                                    required
                                    rows={3}
                                    placeholder="Enter option C here..."
                                    style={{ resize: 'vertical' }}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="option-d" className="form-label text-gray-700">Option D <span className="text-danger">*</span></label>
                                <textarea
                                    id="option-d"
                                    value={optionD}
                                    onChange={(e) => setOptionD(e.target.value)}
                                    className="form-control"
                                    required
                                    rows={3}
                                    placeholder="Enter option D here..."
                                    style={{ resize: 'vertical' }}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="correct-option" className="form-label text-gray-700">Correct Option <span className="text-danger">*</span></label>
                                <select
                                    id="correct-option"
                                    value={correctOption}
                                    onChange={(e) => setCorrectOption(e.target.value)}
                                    className="form-select"
                                    required
                                >
                                    <option value="" disabled>SELECT</option>
                                    {CORRECTOPTION.map((corrOpp) => (
                                        <option key={corrOpp} value={corrOpp}>
                                            {corrOpp}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="answer-explanation" className="form-label text-gray-700">Answer Explanation</label>
                                <textarea
                                    id="answer-explanation"
                                    value={answerExplanation}
                                    onChange={(e) => setAnswerExplanation(e.target.value)}
                                    className="form-control"
                                    rows={3}
                                    placeholder="Enter explanation here..."
                                    style={{ resize: 'vertical' }}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="question-level" className="form-label text-gray-700">Question Level <span className="text-danger">*</span></label>
                                <select
                                    id="question-level"
                                    value={level}
                                    onChange={(e) => setLevel(e.target.value)}
                                    className="form-select"
                                    required
                                >
                                    <option value="" disabled>SELECT</option>
                                    {TAGLEVELS.map((item) => (
                                        item.submenu ? (
                                            <optgroup key={item.value} label={item.label}>
                                                {item.submenu.map((sub) => (
                                                    <option key={sub.value} value={sub.value}>
                                                        {sub.label}
                                                    </option>
                                                ))}
                                            </optgroup>
                                        ) : (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        )
                                    ))}
                                </select>
                            </div>

                            {level && level.length > 0 && (
                                <>
                                    <div className="mb-3">
                                        <label className="form-label text-gray-700">Subject <span className="text-danger">*</span></label>
                                        <div className="d-flex flex-wrap gap-2 mb-2">
                                            {subject.split(',').filter(Boolean).map((tag) => (
                                                <span
                                                    key={tag}
                                                    className="badge bg-primary-subtle text-primary fw-normal py-2 px-3 rounded-pill d-flex align-items-center"
                                                >
                                                    {tag}
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setSubject(
                                                                subject
                                                                    .split(',')
                                                                    .filter((t) => t !== tag)
                                                                    .join(',')
                                                            )
                                                        }
                                                        className="btn-close ms-2"
                                                        aria-label="Remove tag"
                                                    ></button>
                                                </span>
                                            ))}
                                        </div>
                                        <select
                                            value=""
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const current = subject.split(',').filter(Boolean);
                                                if (value && !current.includes(value)) {
                                                    setSubject([...current, value].join(','));
                                                }
                                            }}
                                            className="form-select"
                                            required
                                        >
                                            <option value="" disabled>
                                                SELECT
                                            </option>
                                            {tags
                                                .filter((tag) => tag.level === level && tag.tag_type === 'SUBJECT')
                                                .map((tag) => (
                                                    <option key={tag.name} value={tag.name}>
                                                        {tag.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label text-gray-700">Topic</label>
                                        <div className="d-flex flex-wrap gap-2 mb-2">
                                            {topic.split(',').filter(Boolean).map((tag) => (
                                                <span
                                                    key={tag}
                                                    className="badge bg-primary-subtle text-primary fw-normal py-2 px-3 rounded-pill d-flex align-items-center"
                                                >
                                                    {tag}
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setTopic(
                                                                topic
                                                                    .split(',')
                                                                    .filter((t) => t !== tag)
                                                                    .join(',')
                                                            )
                                                        }
                                                        className="btn-close ms-2"
                                                        aria-label="Remove tag"
                                                    ></button>
                                                </span>
                                            ))}
                                        </div>
                                        <select
                                            value=""
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const current = topic.split(',').filter(Boolean);
                                                if (value && !current.includes(value)) {
                                                    setTopic([...current, value].join(','));
                                                }
                                            }}
                                            className="form-select"
                                            required
                                        >
                                            <option value="" disabled>
                                                SELECT
                                            </option>
                                            {tags
                                                .filter((tag) => tag.level === level && tag.tag_type === 'TOPIC')
                                                .map((tag) => (
                                                    <option key={tag.name} value={tag.name}>
                                                        {tag.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label text-gray-700">Exam</label>
                                        <div className="d-flex flex-wrap gap-2 mb-2">
                                            {exam.split(',').filter(Boolean).map((tag) => (
                                                <span
                                                    key={tag}
                                                    className="badge bg-primary-subtle text-primary fw-normal py-2 px-3 rounded-pill d-flex align-items-center"
                                                >
                                                    {tag}
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setExam(
                                                                exam?.split(',')
                                                                    .filter((t) => t !== tag)
                                                                    .join(',')
                                                            )
                                                        }
                                                        className="btn-close ms-2"
                                                        aria-label="Remove tag"
                                                    ></button>
                                                </span>
                                            ))}
                                        </div>
                                        <select
                                            value=""
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const current = exam.split(',').filter(Boolean);
                                                if (value && !current.includes(value)) {
                                                    setExam([...current, value].join(','));
                                                }
                                            }}
                                            className="form-select"
                                            required
                                        >
                                            <option value="" disabled>
                                                SELECT
                                            </option>
                                            {tags
                                                .filter((tag) => tag.level === level && tag.tag_type === 'EXAM')
                                                .map((tag) => (
                                                    <option key={tag.name} value={tag.name}>
                                                        {tag.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </>
                            )}

                            <div className="mb-3">
                                <label htmlFor="difficulty" className="form-label text-gray-700">Difficulty <span className="text-danger">*</span></label>
                                <select
                                    id="difficulty"
                                    value={difficulty}
                                    onChange={(e) => setDifficulty(e.target.value)}
                                    className="form-select"
                                    required
                                >
                                    <option value="" disabled>SELECT</option>
                                    {QUESTIONDIFFICULTY.map((diffclty) => (
                                        <option key={diffclty} value={diffclty}>
                                            {diffclty}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer d-flex justify-content-end gap-3 pt-3 border-top bg-white">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="btn btn-secondary px-4 py-2 rounded-3"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleSave}
                            disabled={!isFormValid || isSaving}
                            className={`btn btn-primary px-4 py-2 rounded-3 ${
                                (!isFormValid || isSaving) ? 'btn-secondary disabled' : 'btn-success'
                            }`}
                        >
                            {isSaving ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </div>
            </div>
            <QuestionPreviewModal
                open={showPreview}
                onClose={() => setShowPreview(false)}
                fields={{
                    questionText: text,
                    questionType: 'MCQ',
                    correctOptions: String(correctOption || '').split(',').map(s => s.trim()).filter(Boolean),
                    options: { A: optionA, B: optionB, C: optionC, D: optionD },
                }}
            />
        </div>
    );
};

// Resolution Modal Component
const ResolutionModal = ({ report, onClose, onResolveSuccess }) => {
    const [newResolutionStatus, setNewResolutionStatus] = useState(report.resolution_status);
    const [resolutionComment, setResolutionComment] = useState(report.resolution_comment || '');
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const CallApi = useApiCaller();

    const handleSubmitResolution = async () => {
        setSubmitting(true);
        setSubmitError(null);
        try {
            const putPayload = constructReportedQuestionPutPayload(newResolutionStatus, resolutionComment);
            const putUrl = reportedQuestionPutUrl(report.report_id);
            const response = await CallApi({
                url: putUrl,
                method: 'PUT',
                token: true,
                payload: putPayload
            });

            if (response.success) {
                console.log('Resolution updated successfully!');
                onResolveSuccess();
                onClose();
            } else {
                setSubmitError(response.message || 'Failed to update resolution.');
            }
        } catch (err) {
            console.error("Error updating resolution:", err);
            setSubmitError('An error occurred while updating resolution.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title fs-4 fw-bold text-dark border-bottom pb-3">Resolve Report #{report.report_id}</h5>
                        <CloseButton onClick={onClose} style={{ top: '1rem', right: '1rem' }} />
                    </div>
                    <div className="modal-body">
                        <p className="mb-2 text-gray-700">Question ID: <span className="fw-semibold">{report.question_id}</span></p>
                        <p className="mb-4 text-gray-700">Reported by: <span className="fw-semibold">{report.user_email}</span></p>

                        <div className="mb-3">
                            <label htmlFor="resolutionStatus" className="form-label fw-semibold text-gray-700">Resolution Status:</label>
                            <select
                                id="resolutionStatus"
                                value={newResolutionStatus}
                                onChange={(e) => setNewResolutionStatus(e.target.value)}
                                className="form-select"
                            >
                                <option value="pending">Pending</option>
                                <option value="resolved">Resolved</option>
                                <option value="not_resolved">Not Resolved</option>
                                <option value="no_action_needed">No Action Needed</option>
                            </select>
                        </div>

                        <div className="mb-4">
                            <label htmlFor="resolutionComment" className="form-label fw-semibold text-gray-700">Resolution Comment (optional):</label>
                            <textarea
                                id="resolutionComment"
                                value={resolutionComment}
                                onChange={(e) => setResolutionComment(e.target.value)}
                                rows="4"
                                className="form-control"
                                placeholder="Add a comment about the resolution..."
                                style={{ resize: 'vertical' }}
                            ></textarea>
                        </div>

                        {submitError && <p className="text-danger text-center mb-3">{submitError}</p>}

                        <button
                            onClick={handleSubmitResolution}
                            disabled={submitting}
                            className={`btn w-100 px-4 py-2 rounded-3 fw-semibold ${
                                submitting ? 'btn-secondary disabled' : 'btn-success'
                            }`}
                        >
                            {submitting ? 'Submitting...' : 'Submit Resolution'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


// Reported Questions Grid Component
const ReportedQuestionsGrid = () => {
    const CallApi = useApiCaller();
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50); // Default items per page
    const [totalReports, setTotalReports] = useState(0);

    const [pendingFilters, setPendingFilters] = useState({
        user_email: '',
        resolution_status: '',
        reason_wrong_text: false,
        reason_wrong_answer: false,
        reason_bad_question: false,
        reason_out_of_syllabus: false,
        reason_other: false,
    });

    const [appliedFilters, setAppliedFilters] = useState({
        user_email: '',
        resolution_status: '',
        reason_wrong_text: false,
        reason_wrong_answer: false,
        reason_bad_question: false,
        reason_out_of_syllabus: false,
        reason_other: false,
    });


    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState(null);

    const [showResolutionModal, setShowResolutionModal] = useState(false);
    const [selectedReportForResolution, setSelectedReportForResolution] = useState(null);

    const fetchReports = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            let params = {
                page,
                limit
            };
            if (!isEmpty(appliedFilters.user_email)) {
                params["user_email"] = appliedFilters.user_email;
            }
            if (!isEmpty(appliedFilters.resolution_status)) {
                params["resolution_status"] = appliedFilters.resolution_status;
            }


            if (appliedFilters.reason_wrong_text) {
                params["reason_wrong_text"] = appliedFilters.reason_wrong_text;
            }
            if (appliedFilters.reason_wrong_answer) {
                params["reason_wrong_answer"] = appliedFilters.reason_wrong_answer;
            }
            if (appliedFilters.reason_bad_question) {
                params["reason_bad_question"] = appliedFilters.reason_bad_question;
            }
            if (appliedFilters.reason_out_of_syllabus) {
                params["reason_out_of_syllabus"] = appliedFilters.reason_out_of_syllabus;
            }
            if (appliedFilters.reason_other) {
                params["reason_other"] = appliedFilters.reason_other;
            }
            
            const geturl = reportedQuestionGetUrl(params);
            const response = await CallApi({ 
                url: geturl, 
                method: 'GET', 
                token: true 
            });

            if (response.success) {
                setReports(response.data.reports);
                setTotalReports(response.data.total);
            } else {
                setError('Failed to fetch reported questions.');
            }
        } catch (err) {
            setError('An unexpected error occurred while fetching reports.');
            console.error("Fetch reports error:", err);
        } finally {
            setLoading(false);
        }
    }, [page, limit, appliedFilters]);

    useEffect(() => {
        fetchReports();
    }, [fetchReports]);

    const handlePendingFilterChange = (e) => {
        const { name, value, type, checked } = e.target;
        setPendingFilters(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleApplyFilters = () => {
        setAppliedFilters(pendingFilters);
        setPage(1);
    };

    const handleClearFilters = () => {
        const clearedState = {
            user_email: '',
            resolution_status: '',
            reason_wrong_text: false,
            reason_wrong_answer: false,
            reason_bad_question: false,
            reason_out_of_syllabus: false,
            reason_other: false,
        };
        setPendingFilters(clearedState);
        setAppliedFilters(clearedState);
        setPage(1);
    };

    const handleLimitChange = (e) => {
        setLimit(parseInt(e.target.value));
        setPage(1);
    };

    // const handlePageChange = (newPage) => {
    //     if (newPage > 0 && newPage <= Math.ceil(totalReports / limit)) {
    //         setPage(newPage);
    //     }
    // };

    const handlePageChange = (dir) => {
        setPage(prev => {
            if (dir === 'prev') return prev === 1 ? Math.ceil(totalReports / limit) : prev - 1;
            if (dir === 'next') return prev === Math.ceil(totalReports / limit) ? 1 : prev + 1;
        });
    };

    const handleEditQuestion = async (questionId) => {
        setLoading(true);
        setError(null);
        try {
            const url = getAdminQuestionGetByIdUrl(questionId);
            const response = await CallApi({ url, method: 'GET', token: true });
            if (response.success) {
                setSelectedQuestion(response.data);
                setShowEditModal(true);
            } else {
                setError(response.message || 'Failed to fetch question details for editing.');
            }
        } catch (err) {
            setError('An unexpected error occurred while fetching question details.');
            console.error("Fetch question for edit error:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveQuestion = (updatedQuestion) => {
        console.log("Question saved:", updatedQuestion);
        setShowEditModal(false);
        setSelectedQuestion(null);
        fetchReports();
    };

    const handleCancelEdit = () => {
        setShowEditModal(false);
        setSelectedQuestion(null);
    };

    const handleOpenResolutionModal = (report) => {
        setSelectedReportForResolution(report);
        setShowResolutionModal(true);
    };

    const handleCloseResolutionModal = () => {
        setShowResolutionModal(false);
        setSelectedReportForResolution(null);
    };

    const handleResolutionSuccess = () => {
        handleCloseResolutionModal();
        fetchReports();
    };

    return (
        <div className="container-fluid p-4 bg-light min-h-screen">
            <h1 className="fw-bold mb-4" style={{ fontSize: '1.6rem', color: '#5b21b6' }}>Reported Questions</h1>

            {/* Filters */}
            <div className="card shadow-sm mb-4 kp-filter">
                <div className="card-body">
                    <div className="row g-3 align-items-end">
                        <div className="col-md-6 col-lg-3">
                            <label htmlFor="user_email" className="form-label text-gray-700">User Email</label>
                            <input
                                type="text"
                                id="user_email"
                                name="user_email"
                                value={pendingFilters.user_email}
                                onChange={handlePendingFilterChange}
                                className="form-control"
                                placeholder="Filter by user email"
                            />
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <label htmlFor="resolution_status" className="form-label text-gray-700">Resolution Status</label>
                            <select
                                id="resolution_status"
                                name="resolution_status"
                                value={pendingFilters.resolution_status}
                                onChange={handlePendingFilterChange}
                                className="form-select"
                            >
                                <option value="">All</option>
                                <option value="pending">Pending</option>
                                <option value="resolved">Resolved</option>
                                <option value="not_resolved">Not Resolved</option>
                                <option value="no_action_needed">No Action Needed</option>
                            </select>
                        </div>
                        <div className="col-12 col-lg-4">
                            <label className="form-label text-gray-700 mb-2">Reasons</label>
                            <div className="d-flex flex-wrap gap-3">
                                <div className="form-check">
                                    <input
                                        id="reason_wrong_text"
                                        name="reason_wrong_text"
                                        type="checkbox"
                                        checked={pendingFilters.reason_wrong_text}
                                        onChange={handlePendingFilterChange}
                                        className="form-check-input"
                                    />
                                    <label htmlFor="reason_wrong_text" className="form-check-label text-gray-900">Wrong Text</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        id="reason_wrong_answer"
                                        name="reason_wrong_answer"
                                        type="checkbox"
                                        checked={pendingFilters.reason_wrong_answer}
                                        onChange={handlePendingFilterChange}
                                        className="form-check-input"
                                    />
                                    <label htmlFor="reason_wrong_answer" className="form-check-label text-gray-900">Wrong Answer</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        id="reason_bad_question"
                                        name="reason_bad_question"
                                        type="checkbox"
                                        checked={pendingFilters.reason_bad_question}
                                        onChange={handlePendingFilterChange}
                                        className="form-check-input"
                                    />
                                    <label htmlFor="reason_bad_question" className="form-check-label text-gray-900">Bad Question</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        id="reason_out_of_syllabus"
                                        name="reason_out_of_syllabus"
                                        type="checkbox"
                                        checked={pendingFilters.reason_out_of_syllabus}
                                        onChange={handlePendingFilterChange}
                                        className="form-check-input"
                                    />
                                    <label htmlFor="reason_out_of_syllabus" className="form-check-label text-gray-900">Out of Syllabus</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        id="reason_other"
                                        name="reason_other"
                                        type="checkbox"
                                        checked={pendingFilters.reason_other}
                                        onChange={handlePendingFilterChange}
                                        className="form-check-input"
                                    />
                                    <label htmlFor="reason_other" className="form-check-label text-gray-900">Other</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-2 d-flex justify-content-end gap-3">
                            <button
                                onClick={handleApplyFilters}
                                className="btn btn-primary w-100"
                            >
                                Apply Filters
                            </button>
                            <button
                                onClick={handleClearFilters}
                                className="btn btn-outline-secondary w-100"
                            >
                                Clear Filters
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Reports Table */}
            <div className="card shadow-sm overflow-hidden">
                {loading ? (
                    <div className="p-4 text-center text-secondary">Loading reports...</div>
                ) : error ? (
                    <div className="p-4 text-center text-danger">{error}</div>
                ) : reports.length === 0 ? (
                    <div className="p-4 text-center text-secondary">No reported questions found.</div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead className="table-light">
                                <tr>

                                    <th scope="col" className="px-3 py-2 text-start text-uppercase text-secondary fs-6">User Email</th>
                                    <th scope="col" className="px-3 py-2 text-start text-uppercase text-secondary fs-6">Question Id</th>
                                    <th scope="col" className="px-3 py-2 text-start text-uppercase text-secondary fs-6">Report Reason</th>
                                    <th scope="col" className="px-3 py-2 text-start text-uppercase text-secondary fs-6">User Comment</th>
                                    <th scope="col" className="px-3 py-2 text-start text-uppercase text-secondary fs-6">Resolve Status</th>
                                    <th scope="col" className="px-3 py-2 text-start text-uppercase text-secondary fs-6">Admin Comment</th>
                                    <th scope="col" className="px-3 py-2 text-center text-uppercase text-secondary fs-6">Edit Question</th>
                                    <th scope="col" className="px-3 py-2 text-center text-uppercase text-secondary fs-6">Edit Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reports.map((report) => (
                                    <tr key={report.report_id}>
                                        <td className="px-3 py-2 text-nowrap text-secondary">{report.user_email}</td>
                                        <td className="px-3 py-2 text-nowrap text-secondary">{report.question_id}</td>
                                        <td className="px-3 py-2 text-nowrap text-secondary">
                                            {report.reason_wrong_text ? <span className="badge bg-danger-subtle text-danger me-1 mb-1">Wrong Text</span> : null}
                                            {report.reason_wrong_answer ? <span className="badge bg-danger-subtle text-danger me-1 mb-1">Wrong Answer</span> : null}
                                            {report.reason_bad_question ? <span className="badge bg-danger-subtle text-danger me-1 mb-1">Bad Question</span> : null}
                                            {report.reason_out_of_syllabus ? <span className="badge bg-danger-subtle text-danger me-1 mb-1">Out of Syllabus</span> : null}
                                            {report.reason_other ? <span className="badge bg-danger-subtle text-danger me-1 mb-1">Other</span> : null}
                                        </td>
                                        <td className="px-3 py-2 text-nowrap text-secondary">{report.comment || '-'}</td>
                                        <td className="px-3 py-2 text-nowrap">
                                            <span className={`badge ${
                                                report.resolution_status === 'resolved' ? 'bg-success-subtle text-success' :
                                                report.resolution_status === 'pending' ? 'bg-warning-subtle text-warning' :
                                                report.resolution_status === 'not_resolved' ? 'bg-danger-subtle text-danger' :
                                                'bg-secondary-subtle text-secondary'
                                            }`}>
                                                {report.resolution_status.replace(/_/g, ' ')}
                                            </span>
                                        </td>
                                        <td className="px-3 py-2 text-nowrap text-secondary">{report.resolution_comment || '-'}</td>
                                        <td className="px-3 py-2 text-center">
                                            <button
                                                onClick={() => handleEditQuestion(report.question_id)}
                                                className="btn btn-link text-primary p-0"
                                                title="Edit Question"
                                            >
                                                <Edit className="w-5 h-5" />
                                            </button>
                                        </td>
                                        <td className="px-3 py-2 text-center">
                                            <button
                                                onClick={() => handleOpenResolutionModal(report)}
                                                className="btn btn-link text-info p-0"
                                                title="Resolve Report"
                                            >
                                                <BookOpen className="w-5 h-5" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Pagination and Items per page */}
            <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="d-flex align-items-center gap-2">
                    <label htmlFor="pageSizeSelect" className="form-label text-secondary mb-0">Items per page:</label>
                    <select
                        id="items-per-page"
                        value={limit}
                        onChange={handleLimitChange}
                        className="form-select form-select-sm w-auto"
                    >
                        {itemsPerPageOptions.map(option => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select>
                </div>
                <div className="d-flex align-items-center gap-3">
                    <button
                        onClick={() => handlePageChange('prev')}
                        disabled={loading}
                        className="btn btn-outline-secondary rounded-pill"
                    >
                        <ChevronLeftIcon className="w-4 h-4 me-1" /> Previous
                    </button>
                    <span className="text-secondary">Page {page} of {Math.ceil(totalReports / limit) || 1} · Total: {totalReports}</span>
                    <button
                        onClick={() => handlePageChange('next')}
                        disabled={loading}
                        className="btn btn-outline-secondary rounded-pill"
                    >
                        Next <ChevronRightIcon className="w-4 h-4 ms-1" />
                    </button>
                </div>
            </div>

            {/* Question Edit Modal */}
            {showEditModal && selectedQuestion && (
                <QuestionEditForm
                    question={selectedQuestion}
                    onCancel={handleCancelEdit}
                    onSave={handleSaveQuestion}
                />
            )}

            {/* Resolution Modal */}
            {showResolutionModal && selectedReportForResolution && (
                <ResolutionModal
                    report={selectedReportForResolution}
                    onClose={handleCloseResolutionModal}
                    onResolveSuccess={handleResolutionSuccess}
                />
            )}
        </div>
    );
};

export default ReportedQuestionsGrid;
